import { Alert, AlertTitle, Backdrop, Button, Fade, Grid, Modal, Stack } from '@mui/material';
import MainCard from 'components/MainCard';
import { actionNotification } from 'hooks/use-action-notification';

const ErrorModal: React.VFC = () => {
  const { errorMessage, clearErrorMessage } = actionNotification.useController();

  if (!Boolean(errorMessage)) {
    return null;
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={true}
      onClose={() => clearErrorMessage()}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500
        }
      }}
    >
      <Fade in={true}>
        <MainCard title="Exception" modal darkTitle content={false} sx={{ minWidth: '100px', maxWidth: '500px' }}>
          <Grid container rowSpacing={5}>
            <Grid item xs={12}>
              <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                {errorMessage}
              </Alert>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={1}>
              <Button onClick={() => clearErrorMessage()}>Ok</Button>
            </Stack>
          </Grid>
        </MainCard>
      </Fade>
    </Modal>
  );
};

export default ErrorModal;
